module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/cc-serasa-modal-lc/cc-serasa-modal-lc.component.scss
// module id = ./src/app/limit-flow-proposal/component/limit-flow-proposal/cc-serasa-modal-lc/cc-serasa-modal-lc.component.scss
// module chunks = main